module.exports = __webpack_public_path__ + "static/media/logo-img.094c5b90.jpg";